import NotFoundImage from '@/assets/images/404.svg'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import HomeIcon from '@/assets/images/icons/HomeIcon.svg'

export function ErrorNotFound() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex w-full flex-col items-center">
      <h3 className=" mt-36 text-primary-dark">
        {t('error_messages.page_not_found')}
      </h3>
      <img src={NotFoundImage} className="w-[500px]"></img>
      <div
        className="transition-duration-300 mt-8 flex cursor-pointer items-center gap-2 rounded-full bg-[rgb(1_72_165)] px-4 py-2 text-white shadow-md transition-colors hover:bg-[rgb(27_117_235)]"
        onClick={() => {
          navigate(`/`)
        }}
      >
        <img src={HomeIcon} className="size-5" />
        {t('drawer_pages.home')}
      </div>
    </div>
  )
}

export default ErrorNotFound
